import moment from 'moment'

export const objectToSelectOptions = (obj) => {
    const options = []
    Object.keys(obj).forEach(key => {
        options.push({ value: key === 'null' ? null : key, text: obj[key] })
    })
    return options
}

export const applyTransparency = (color, opacity) => {
    // Remover #
    let hex = color.replace("#", "");

    // Soportar #abc
    if (hex.length === 3) {
        hex = hex
            .split("")
            .map((c) => c + c)
            .join("");
    }

    // Convertir opacidad (0–1) a hex
    const alpha = Math.round(opacity * 255)
        .toString(16)
        .padStart(2, "0");

    return `#${hex}${alpha}`;
}

export const thousandSeparator = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export const subtractDays = (date, days) => {
    return moment(date).subtract(days, 'days').format('YYYY-MM-DD')
}

export default {
    objectToSelectOptions,
    applyTransparency,
    thousandSeparator,
    subtractDays
}